exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-8 {\n  margin-top: 8px;\n}\n.btn {\n  font-weight: bold;\n  background-color: #3B8686;\n  color: #fff;\n  align-self: flex-end;\n}\n.btn-field-add {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n.btn-outline {\n  font-weight: bold;\n  background-color: #fff;\n  border: 1px solid #3B8686;\n  color: #3B8686;\n  align-self: flex-end;\n}\n.btn-field {\n  align-self: flex-end;\n}", ""]);

// exports
